import TariffTable from '@/views/NewOrder/TariffTable'

import NewOrderV2 from '@/views/NewOrder/NewIndex'
import NewOrderV4 from '@/views/NewOrder/IndexV4'
import WelcomeSetSuccessPage from '@/views/NewOrder/WelcomeSetSuccessPage'
import store from '@/store'
const CMZ_AB = '70BZ'

export const newOrderSelectTariff = {
  path: '/new-order-tariff/',
  name: 'NewOrderSelectTariff',
  component: TariffTable,
  meta: { requiredGoals: true, requiredVcp: true },
  beforeEnter: (to, from, next) => {
    next()
  },
}

export const newOrder = {
  path: '/new-order/:goal?/:plan?',
  name: 'NewOrder',
  component: NewOrderV4, // TODO: If something is wrong change it back to NewOrder (import NewOrder from '@/views/NewOrder/')
  meta: { requiredGoals: true, requiredVcp: true },
  beforeEnter: (to, from, next) => {
    const cmz = store.getters['marketing/specificQueryParams']?.cmz || null
    if (cmz === CMZ_AB) {
      next({
        ...to,
        name: newOrderV2.name,
      })
    } else {
      next()
    }
  },
}

export const newOrderV2 = {
  path: '/new-order-v2/:goal?/:plan?',
  name: 'NewOrderV2',
  component: NewOrderV2,
  meta: { requiredGoals: true, requiredVcp: true },
  beforeEnter: (to, from, next) => {
    const cmz = store.getters['marketing/specificQueryParams']?.cmz || null
    if (cmz === CMZ_AB) {
      next()
    } else {
      next({
        ...to,
        name: newOrder.name,
      })
    }
  },
}

export const newOrderV4 = {
  path: '/new-order-v4/:goal?/:plan?',
  name: 'NewOrderV4',
  component: NewOrderV4,
  meta: { requiredGoals: true, requiredVcp: true },
}

export const newOrderTariff = {
  path: '/new-order-tariff/:tariff?/:goal?/:plan?',
  name: 'NewOrderTariff',
  component: NewOrderV4,
  meta: { requiredGoals: true, requiredVcp: true },
}

export const welcomeSetSuccessPage = {
  path: '/welcome-set-success',
  name: 'WelcomeSetSuccessPage',
  component: WelcomeSetSuccessPage,
  meta: { requiredGoals: false, requiredVcp: false },
}

export default newOrder
